function About() {
  return (
    <div className="min-h-screen px-3 sm:px-4 lg:px-6 py-4 sm:py-6 lg:py-8" style={{ backgroundColor: '#F8F9FA' }}>
      <div className="max-w-[900px] mx-auto bg-white dark:bg-gray-900 rounded-[32px] border border-gray-200 dark:border-gray-700 overflow-hidden shadow-lg transition-colors">
        
        {/* Header */}
        <div className="p-8 md:p-12 border-b border-gray-100 dark:border-gray-700 bg-slate-50/50 dark:bg-gray-800/50">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6">
            <div>
              <h1 className="text-4xl font-bold tracking-tight text-gray-900 dark:text-white mb-2">
                Giới thiệu
              </h1>
              <p className="text-blue-600 dark:text-blue-400 font-semibold tracking-wide uppercase text-sm">
                Dự án Kỹ năng làm việc
              </p>
            </div>
            <img 
              src="/fpt-logo.png" 
              alt="FPT Polytechnic" 
              className="h-12 w-auto object-contain"
            />
          </div>
        </div>

        {/* Content */}
        <div className="p-8 md:p-12">
          <section className="space-y-6 text-lg text-gray-600 dark:text-gray-300">
            <p>
              Chúng tôi là một nhóm sinh viên đến từ{' '}
              <strong className="text-gray-900 dark:text-white">FPT Polytechnic</strong>, thực hiện website này như một phần của dự án phục vụ môn Kỹ năng làm việc.
            </p>
            <div className="bg-blue-50 dark:bg-blue-900/20 p-6 rounded-2xl border-l-4 border-blue-600 dark:border-blue-400">
              <p className="text-gray-800 dark:text-gray-200">
                Website được xây dựng với mục tiêu tạo ra một không gian để chia sẻ, lưu trữ và tham khảo các prompt liên quan đến tạo ảnh AI. 
                Đây là một sản phẩm mang tính học tập, thực hành và trải nghiệm thực tế trong quá trình làm việc nhóm, xây dựng ý tưởng và triển khai một dự án web hoàn chỉnh.
              </p>
            </div>
          </section>

          <div className="h-px bg-gray-200 dark:bg-gray-700 my-10"></div>

          <section>
            <h2 className="text-2xl font-bold mb-8 text-gray-900 dark:text-white">
              Mục đích của website
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {[
                {
                  number: '01',
                  text: 'Hỗ trợ người dùng dễ dàng lưu trữ và tham khảo prompt tạo ảnh AI'
                },
                {
                  number: '02',
                  text: 'Tạo thêm một nguồn nội dung hữu ích cho cộng đồng quan tâm đến AI'
                },
                {
                  number: '03',
                  text: 'Giúp nhóm có cơ hội áp dụng kiến thức đã học vào một sản phẩm thực tế'
                },
                {
                  number: '04',
                  text: 'Rèn luyện kỹ năng làm việc nhóm, phân chia công việc và phối hợp trong quá trình thực hiện dự án'
                }
              ].map((goal) => (
                <div 
                  key={goal.number}
                  className="flex items-start gap-4 p-4 rounded-2xl transition-all hover:bg-gray-50 dark:hover:bg-gray-800"
                >
                  <div className="bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 min-w-[32px] h-8 flex items-center justify-center rounded-full font-bold text-sm">
                    {goal.number}
                  </div>
                  <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
                    {goal.text}
                  </p>
                </div>
              ))}
            </div>
          </section>

          <div className="h-px bg-gray-200 dark:bg-gray-700 my-10"></div>

          <section className="bg-gradient-to-br from-blue-600 to-blue-700 dark:from-blue-700 dark:to-blue-800 rounded-[24px] p-8 text-white shadow-xl">
            <h2 className="text-xl font-bold mb-4">Tính chất của dự án</h2>
            <p className="opacity-90 mb-6">
              Đây là dự án học tập phi thương mại, tập trung vào kiến thức:
            </p>
            <div className="flex flex-wrap gap-3">
              <span className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full text-sm font-medium">
                ✓ Phục vụ môn học
              </span>
              <span className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full text-sm font-medium">
                ✓ Nâng cao thực hành
              </span>
              <span className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full text-sm font-medium">
                ✓ Không lợi nhuận
              </span>
            </div>
            <p className="mt-6 pt-6 border-t border-white/10 text-sm opacity-80 italic">
              Hiện tại, website không phục vụ mục đích kinh doanh, không thu phí người dùng và không đặt nặng yếu tố lợi nhuận.
            </p>
          </section>

          <div className="h-px bg-gray-200 dark:bg-gray-700 my-10"></div>

          <section className="space-y-4">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white italic">
              Lời nhắn từ nhóm
            </h2>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
              Vì đây là sản phẩm được thực hiện bởi sinh viên trong quá trình học tập và hoàn thiện kỹ năng, 
              website chắc chắn vẫn còn nhiều điểm chưa hoàn thiện và có thể tồn tại một số thiếu sót trong nội dung, 
              giao diện hoặc trải nghiệm sử dụng.
            </p>
            <p className="text-gray-600 dark:text-gray-300">
              Nhóm chúng tôi rất mong nhận được sự thông cảm, góp ý và phản hồi từ mọi người để có thể tiếp tục 
              cải thiện sản phẩm tốt hơn trong tương lai.
            </p>
          </section>

          <div className="h-px bg-gray-200 dark:bg-gray-700 my-10"></div>

          <footer className="text-center pt-4">
            <p className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
              Lời cảm ơn ❤️
            </p>
            <p className="text-gray-500 dark:text-gray-400 max-w-2xl mx-auto italic leading-relaxed">
              Chúng tôi xin chân thành cảm ơn thầy cô, bạn bè và những người đã quan tâm, đóng góp ý kiến cho dự án. 
              Mọi sự ủng hộ và góp ý đều là động lực để nhóm tiếp tục học hỏi và hoàn thiện hơn.
            </p>
            <div className="mt-12 flex items-center justify-center gap-2 text-xs font-bold text-gray-300 dark:text-gray-600 uppercase tracking-widest">
              <span className="material-symbols-rounded text-sm">school</span>
              FPT Polytechnic Student Project
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
}

export default About;
